import React, { Fragment } from 'react';
import styled from 'styled-components';
import {
  FONT_FAMILY_MAIN, LINKS_COLOR, NOTES_COLOR, TEXT_COLOR,
} from '../../theme';

const Title = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin-bottom: 8px;
`;

const Text = styled.p`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  
  & + & {
    margin-top: 12px;
  }
  
  a {
    color: ${LINKS_COLOR};
  }
`;

const Note = styled.p`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
`;

const PopupContent = () => (
  <>
    <Title>Compte suspendu</Title>
    <Text>
      Le compte de cette auto-école a été suspendu. Nous vous invitons à vous tourner vers une autre auto-école
      pour effectuer votre formation.
    </Text>
    <Text>
      L’équipe&nbsp;
      <a href="/">Vroomvroom.fr</a>
    </Text>
    <Note>Vous êtes le gérant de cette auto-école? Contactez-nous afin de réactiver votre compte.</Note>
  </>
);

export { PopupContent };
